<template>
  <el-dialog v-if="visible" :visible.sync="visible" class="download-preview-dialog" width="1200px">
    <div class="page-wrap" style="flex: 1; transform: translateY(-12px)">
      <i class="el-icon-close icon-button" @click="visible = false"></i>
    </div>
    <div style="transform: translateY(-12px)">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in downTemplates" :key="item[0]" :label="$t(item[1].key)" :name="item[0]" />
      </el-tabs>
    </div>
    <on-job :lang="currentTem.lang" :form="content">
      <component :is="currentTem.com" :type="currentTem.lang" :form="content" :currentTem="currentTem" />
    </on-job>
  </el-dialog>
</template>

<script>
import OnJob from './staff-template'
import downTemplates, { all } from './staff-template/slot/tem-map'
export default {
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    staffData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    OnJob
  },
  computed: {
    // 模版列表
    downTemplates() {
      let data = all
      const sendLanguage = this.staffData.send_language
      if (this.staffData.send_language) {
        const keys = Object.keys(downTemplates)
        if (sendLanguage.length === keys.length) {
          data = all
        } else {
          keys.forEach(item => {
            if (this.staffData.send_language.includes(item)) data = downTemplates[item]
          })
        }
      }
      return data
    },
    currentTem() {
      return this.downTemplates.get(this.activeName)
    }
  },
  data() {
    return {
      visible: false,
      activeName: '1'
    }
  }
}
</script>
